<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <component-query :queryMode="playerQueryMode" @usersData="getUsersData"></component-query>

                <el-table :data="playerData" border style="width: 50%;margin-bottom: 20px;"
                          @current-change="handlePlayerDataChange" highlight-current-row>
                  <el-table-column prop="id" label="用户id"  width="120"></el-table-column>
                  <el-table-column prop="server" label="游戏服编号" width="120"></el-table-column>
                  <el-table-column prop="email" label="sid" width="120"></el-table-column>
                  <el-table-column prop="channel" label="渠道" width="120"></el-table-column>
                  <el-table-column prop="nick" label="昵称"></el-table-column>
                  <el-table-column prop="level" label="等级"></el-table-column>
                    <el-table-column label="禁言状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.silence == 0">正常</span>
                            <span v-if="scope.row.silence == 1">禁言</span>
                            <span v-if="scope.row.silence == 2">伪禁言</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="封号状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.block == 0">正常</span>
                            <span v-if="scope.row.block == 1">后台封禁</span>
                            <span v-if="scope.row.block == 2">系统封禁</span>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="query-panel">
                    <el-form :inline="true">
                        <el-form-item label='查询内容'>
                            <el-input v-model="content" placeholder="请输入查询内容"></el-input>
                        </el-form-item>
                        <el-form-item label='时间范围'>
                            <el-date-picker v-model="dateTime" type="datetimerange" range-separator='-'
                                            start-placeholder='开始时间' end-placeholder='结束时间'
                                            format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="留言频道类型">
                            <el-select v-model="msgFindBO.msgType" placeholder="请选择">
                                <el-option
                                    v-for="item in msgTypeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="配置id">
                            <el-select v-model="msgFindBO.configId" placeholder="请选择">
                                <el-option
                                    v-if="msgFindBO.msgType == 1"
                                    v-for="item in mapNodeData"
                                    :key="item.id"
                                    :label="item.id +'-' + $t(item.name)"
                                    :value="item.id">
                                </el-option>
                                <el-option
                                    v-if="msgFindBO.msgType == 2"
                                    v-for="item in monsterConfigData"
                                    :key="item.id"
                                    :label="item.id +'-' + $t(item.name)"
                                    :value="item.id">
                                </el-option>
                                <el-option
                                    v-if="msgFindBO.msgType == 3"
                                    v-for="item in immortalCocoonConfigData"
                                    :key="item.id"
                                    :label="item.id +'-' + $t(item.name)"
                                    :value="item.id">
                                </el-option>
                                <el-option
                                    v-if="msgFindBO.msgType == 5"
                                    v-for="item in resoundEventConfigData"
                                    :key="item.id"
                                    :label="item.id +'-' + $t(item.name)"
                                    :value="item.id">
                                </el-option>
                                <el-option
                                    v-if="msgFindBO.msgType == 6"
                                    v-for="item in resoundEventStoryConfigData"
                                    :key="item.id"
                                    :label="item.id +'-' + $t(item.name)"
                                    :value="item.id">
                                </el-option>
                                <el-option
                                    v-if="msgFindBO.msgType == 7"
                                    v-for="item in resoundEventStyleConfigData"
                                    :key="item.id"
                                    :label="item.id +'-' + $t(item.name)"
                                    :value="item.id">
                                </el-option>
                                <el-option
                                    v-if="msgFindBO.msgType == 8"
                                    v-for="item in tribeNodeConfigData"
                                    :key="item.id"
                                    :label="item.id +'-' + $t(item.name)"
                                    :value="item.id">
                                </el-option>
                                <el-option
                                    v-if="msgFindBO.msgType == 9"
                                    v-for="item in realmConfigData"
                                    :key="item.id"
                                    :label="item.id +'-' + $t(item.name) + item.type"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="findPlayerMsg">查询</el-button>
                        </el-form-item>
                    </el-form>

                    <el-table :data="dataHandled" border style="margin-top:20px;width: 100%">
                        <el-table-column prop="userId" label='用户id'>
                        </el-table-column>
                        <el-table-column prop="nick" label='玩家昵称'>
                        </el-table-column>
                        <el-table-column prop="content" label='聊天信息'>
                        </el-table-column>
                        <el-table-column prop="gmtCreate" :formatter="formatterTime" label='创建时间'>
                        </el-table-column>
                        <el-table-column prop="msgType" label='频道类型'>
                            <template slot-scope="scope">
                                <span v-for="item in msgTypeOptions" v-if="scope.row.msgType == item.value">{{item.label}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label='操作'>
                            <template slot-scope="scope">
                                <el-button type="text" @click="delPlayerMsgShow(scope.row)">清理文本</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                                       layout="total, prev, pager, next, jumper" :total="totalRow">
                        </el-pagination>
                    </div>
                </div>

                <el-dialog title="清理文本" :visible.sync="delPlayerMsgDialog" width="50%" lock-scroll center>
                    <el-form label-suffix=":" label-width="100px">
                        <el-form-item label="内部操作原因">
                            <el-autocomplete
                                class="inline-input"
                                type="textarea"
                                :maxlength="300"
                                show-word-limit
                                :autosize="{ minRows: 2}"
                                v-model="msgDelBO.reason"
                                :fetch-suggestions="querySearchReasonTemplate"
                                placeholder="请输入内容"
                                @select="handleSelectReason"
                            >
                                <template slot-scope="{ item }">
                                    <span class="addr">{{item.reason}}</span>
                                </template>
                            </el-autocomplete>
                        </el-form-item>

                        <el-form-item label="言论标签">
                            <el-autocomplete
                                class="inline-input"
                                type="textarea"
                                :maxlength="20"
                                show-word-limit
                                :autosize="{ minRows: 2}"
                                v-model="msgDelBO.chatLabel"
                                :fetch-suggestions="querySearchOpinionTag"
                                placeholder="请输入内容"
                                @select="handleSelectOpinionTag"
                            >
                                <template slot-scope="{ item }">
                                    <span class="addr">{{item.reason}}</span>
                                </template>
                            </el-autocomplete>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="delPlayerMsgDialog = false">取消</el-button>
                        <el-button type="primary" @click="delPlayerMsg">确认</el-button>
                    </div>
                </el-dialog>
            </section>
        </div>
    </el-card>
</template>

<script>
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import {
        mapState
    } from 'vuex';
    import componentServer from '../../components/component_server'
    import componentQuery from '../../components/component_query'
    import gameApi from '../../service/game_api'
    import commonApi from '../../service/common_api'
    import configSettingApi from '../../service/config_setting_api'
    import Utils from '../../lib/utils'

    export default {
        name: "query_msg",
        data() {
            return {
                Utils: Utils,
                title: this.$route.meta.title,
                playerQueryMode: ['mode_long_id','mode_short_id','mode_nick','mode_email'],
                playerData: [],
                msgTypeOptions: [
                    {
                        value: '1',
                        label: '地图节点留言'
                    },
                    {
                        value: '2',
                        label: '怪兽'
                    },
                    {
                        value: '3',
                        label: '永生'
                    },
                    {
                        value: '5',
                        label: '世界回响-主线故事'
                    },
                    {
                        value: '6',
                        label: '世界回响-故事碎片'
                    },
                    {
                        value: '7',
                        label: '世界回响-F'
                    },
                    {
                        value: '8',
                        label: '部落节点'
                    },
                    {
                        value: '9',
                        label: '领域副本'
                    }
                ],
                configIdOptions: [],

                content: '',
                dateTime: '',

                msgFindBO: {
                    uri: '',
                    uid: '',
                    sid: '',
                    server:'',
                    msgType: '',
                    configId: '',
                    content: '',
                    stime: 0,
                    etime: 0
                },

                mapNodeData: [],
                monsterConfigData: [],
                immortalCocoonConfigData: [],
                resoundEventConfigData: [],
                resoundEventStoryConfigData: [],
                resoundEventStyleConfigData: [],
                tribeNodeConfigData: [],
                realmConfigData: [],

                delPlayerMsgDialog: false,

                // 模板数据
                reasonTemplateData: [],
                msgDelBO: {
                    uri: '',
                    sid: '',
                    server:'',
                    uid: '',
                    id: '',
                    msgType: '',
                    reason: '',
                    chatLabel: ''
                },

                // 言论标签数据
                opinionTagData: [],
                currentNick: '',
            }
        },
        mixins: [paginationController, actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        mounted() {
            this.getAllOptionData();
            this.getReasonListAll();
            this.getOpinionTagListAll();
        },
        methods: {
            getUsersData(val) {
                this.playerData = val;
            },
            handlePlayerDataChange(currentRow) {
                this.currentNick = currentRow.nick;

                this.msgFindBO.uri = currentRow.uri;
                this.msgFindBO.uid = currentRow.id;
                this.msgFindBO.sid = currentRow.email;
                this.msgFindBO.server = currentRow.server;

                this.msgDelBO.uri = currentRow.uri;
                this.msgDelBO.uid = currentRow.id;
                this.msgDelBO.sid = currentRow.email;
                this.msgDelBO.server = currentRow.server;
            },

            getAllOptionData() {
                let self = this;
                let tables = 'map_node,monster_config,immortal_cocoon_config,resound_event_config,resound_event_story_config,resound_event_style_config,tribe_node,realm_config';
                commonApi.getConfs({
                    tables: tables
                }).then(res => {
                    self.mapNodeData = res.map_node;
                    self.monsterConfigData = res.monster_config;
                    self.immortalCocoonConfigData = res.immortal_cocoon_config;
                    self.resoundEventConfigData = res.resound_event_config;
                    self.resoundEventStoryConfigData = res.resound_event_story_config;
                    self.resoundEventStyleConfigData = res.resound_event_style_config;
                    self.tribeNodeConfigData = res.tribe_node;
                    self.realmConfigData = res.realm_config;

                    self.realmConfigData.forEach(item=>{
                        let identifier = item.identifier;
                        for (let monsterConfigDatum of self.monsterConfigData) {
                            if (monsterConfigDatum.id == identifier){
                                item.name = monsterConfigDatum.name;
                            }
                        }
                    })
                })
            },

            // 玩家留言查询
            findPlayerMsg() {
                if (this.msgFindBO.uid == '') {
                    this.$message({
                        type: 'error',
                        message: "未选中玩家"
                    })
                    return;
                } else if (this.msgFindBO.msgType == '') {
                    this.$message({
                        type: 'error',
                        message: "未选择留言类型"
                    })
                    return;
                }

                this.msgFindBO.content = this.content;
                if ('' !== this.dateTime) {
                    this.msgFindBO.stime = this.dateTime[0].getTime();
                    this.msgFindBO.etime = this.dateTime[1].getTime();
                }

                gameApi.findMixedMessages({
                    token: this.token,
                    msgFindBO: this.msgFindBO
                }).then(res => {
                    res.content.msgs.forEach(item => {
                        item.nick = this.currentNick;
                        item.msgType = this.msgFindBO.msgType;
                    })
                    this.dataHandled = res.content.msgs;
                })
            },
            formatterTime(row) {
                var gmtCreate = row.gmtCreate;
                gmtCreate = Utils.formatDate(gmtCreate);
                return gmtCreate;
            },

            delPlayerMsgShow(data) {
                this.delPlayerMsgDialog = true;
                var msgDelBO = this.msgDelBO;
                msgDelBO.id = data.id;
                msgDelBO.msgType = this.msgFindBO.msgType;
                msgDelBO.reason = '';
                msgDelBO.chatLabel = '';
            },

            // 玩家留言删除
            delPlayerMsg() {
                gameApi.delMixedMessage({
                    token: this.token,
                    msgDelBO: this.msgDelBO
                }).then(res => {
                    this.delPlayerMsgDialog = false;
                    this.findPlayerMsg();
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                })
            },

            // 模板列表查询
            getReasonListAll() {
                configSettingApi.reasonList({
                    token: this.token
                }).then(res => {
                    this.reasonTemplateData = res;
                })
            },

            querySearchReasonTemplate(queryString, cb) {
                var data = this.reasonTemplateData;
                var results = queryString ? data.filter(this.createFilter(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            createFilter(queryString) {
                return (data) => {
                    return (data.reason.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelectReason(item) {
                this.msgDelBO.reason = item.reason;
            },

            // 模板列表查询
            getOpinionTagListAll() {
                configSettingApi.opinionTagList({
                    token: this.token
                }).then(res => {
                    this.opinionTagData = res;
                })
            },

            querySearchOpinionTag(queryString, cb) {
                var data = this.opinionTagData;
                var results = queryString ? data.filter(this.createFilterOpinionTag(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            createFilterOpinionTag(queryString) {
                return (data) => {
                    return (data.reason.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelectOpinionTag(item) {
                this.msgDelBO.chatLabel = item.reason;
            },
        },
        components: {
            componentServer,
            componentQuery
        }
    }
</script>

<style scoped>

</style>

<style lang="less">
    .el-table__body tr.current-row>td {
        background-color: coral!important;
        color: #ffffff;
    }

    .inline-input {
        width: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/players/query_msg.vue